import { Card, Typography } from 'antd';
import React from 'react';
import { StatCardProps } from '../../libs/types/src';

const { Title, Text } = Typography;

const StatCard: React.FC<StatCardProps> = ({ label, value }) => {
    return (
        <Card bordered={true} className="demos-stat-card">
            <Title level={3} className="demos-stat-value">{value}</Title>
            <Text type="secondary" className="demos-stat-label">{label}</Text>
        </Card>
    );
};

export default StatCard; 